import { settingsService } from '../services';

// Action types
export const GET_POSITIONS = 'GET_POSITIONS';
export const CREATE_POSITION = 'CREATE_POSITION';
export const UPDATE_POSITION = 'UPDATE_POSITION';
export const DELETE_POSITION = 'DELETE_POSITION';

// Action creators
export const fetchPositions = () => async (dispatch) => {
  try {
    const response = await settingsService.getPositions();
    dispatch({
      type: GET_POSITIONS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching positions:', error);
    throw error;
  }
};

export const addPosition = (data) => async (dispatch) => {
  try {
    const response = await settingsService.createPosition(data);
    dispatch({
      type: CREATE_POSITION,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    console.error('Error creating position:', error);
    throw error;
  }
};

export const editPosition = (id, data) => async (dispatch) => {
  try {
    const response = await settingsService.updatePosition(id, data);
    dispatch({
      type: UPDATE_POSITION,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    console.error('Error updating position:', error);
    throw error;
  }
};

export const removePosition = (id) => async (dispatch) => {
  try {
    await settingsService.deletePosition(id);
    dispatch({
      type: DELETE_POSITION,
      payload: id,
    });
    return id;
  } catch (error) {
    console.error('Error deleting position:', error);
    throw error;
  }
};

export const getPositionsOptions = filters => async (dispatch) => {
  try {
    const response = await settingsService.getPositionsOptions(filters);
    return response.data;
  } catch (error) {
    console.error('Error getting position options:', error);
    throw error;
  }
};

export const saveRombelSettings = data => async (dispatch) => {
  try {
    const response = await settingsService.saveRombelSettings(data);
    return response.data;
  } catch (error) {
    console.error('Error saving rombel settings:', error);
    throw error;
  }
};
